import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Flor G.',
  text: 'Con COCINA VIANDERA pasé de improvisar almuerzos a tener un menú semanal que preparo en 2 horas. Vendí mis primeras 10 viandas la primera semana.'
}, {
  name: 'Martín R.',
  text: 'Las fichas paso a paso son una maravilla: claras y sin tecnicismos. Ahora cocino para la semana y ofrezco packs a vecinos los fines de semana.'
}, {
  name: 'Carla P.',
  text: 'El módulo de costeo me cambió la cabeza: por fin sé cuánto cobrar y estoy ganando dinero con cada vianda.'
}, {
  name: 'Lucía S.',
  text: 'Antes perdía comida y tiempo; ahora tengo lista de compras consolidada y ahorro mucho. Mis clientes vuelven cada semana.'
}, {
  name: 'Juan F.',
  text: 'Me dio confianza para etiquetar y entregar sin miedo: las plantillas de etiquetado y conservación son prácticas y profesionales.'
}, {
  name: 'Valeria M.',
  text: 'Probé los jugos y licuados del bono: aumentaron mi ticket promedio en un 20%. Sencillo de preparar y muy requerido.'
}, {
  name: 'Pedro L.',
  text: 'El plan de 2 semanas fue clave para arrancar rápido. Lo seguí tal cual y me permitió ofrecer delivery semanal sin estrés.'
}, {
  name: 'Ana C.',
  text: 'Me encantaron las recetas para bebés: seguras, fáciles y con texto para padres. Ahora preparo viandas infantiles para familias conocidas.'
}, {
  name: 'Fernanda T.',
  text: 'Gracias a las plantillas pude organizar una tanda de 50 viandas en tiempo récord. La producción dejó de ser caótica.'
}, {
  name: 'Sergio V.',
  text: 'Recomendable 100%. Empecé cocinando para mi casa y en 2 meses sumé clientes por referidos. Las instrucciones son prácticas y aplicables.'
}];
export const TestimonialsSection: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-brand-bg" data-id="element-145">
      <div className="max-w-7xl mx-auto" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-4" data-id="element-148">
            Lo que dicen nuestros alumnos
          </h2>
          <div className="w-24 h-1 bg-brand-soft mx-auto rounded-full" data-id="element-149"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-150">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index % 3 * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border border-brand-cream/50 flex flex-col" data-id="element-151">
              <div className="flex space-x-1 mb-4" data-id="element-152">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-soft text-brand-soft" data-id="element-153" />)}
              </div>
              <p className="text-brand-text-medium italic mb-6 flex-grow" data-id="element-154">
                "{testimonial.text}"
              </p>
              <div className="font-bold text-brand-primary" data-id="element-155">
                — {testimonial.name}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};